export const certifications = [
  { name: "ISO 27001:2022", image: "iso.png" },
  { name: "eIDAS", image: "eidas.png" },
  { name: "CCPA", image: "ccpa.png" },
  { name: "ESIGN act", image: "esign.png" },
  { name: "GDPR", image: "gdpr.png" },
  { name: "SOC 2 Type I", image: "soc1.png" },
  { name: "SOC 2 Type II", image: "soc2.png" },
  { name: "UETA", image: "ueta.png" },
  { name: "HIPAA", image: "hipaa2.png" },
];

export const securityCertifications = [
  { name: "ISO 27001:2022", image: "iso.png" },
  { name: "SOC 2 Type II", image: "soc2.png" },
  { name: "GDPR", image: "gdpr.png" },
  { name: "eIDAS", image: "eidas.png" },
  { name: "ESIGN act", image: "esign.png" },
];

export const capterraCertifications = [
  {
    name: "Capterra FrontRunners",
    image:
      "https://capterra.s3.amazonaws.com/assets/images/gdm-badges/sa-frontrunners-2024.png",
    link: "https://www.softwareadvice.com/electronic-signature/#frontrunners",
  },
  {
    name: "Capterra Shortlist",
    image:
      "https://capterra.s3.amazonaws.com/assets/images/gdm-badges/ca-shortlist-2024.png",
    link: "https://www.capterra.com/digital-signature-software/shortlist/",
  },
];

export const BasicChipCertification = [
  { name: "eIDAS", image: "eidas.png" },
  { name: "ESIGN act", image: "esign.png" },
  { name: "UETA", image: "ueta.png" },
]
